<template>
    <div class="base-voucher" :class="{'voucher-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="item" :class="{isitem: activeNav == index}" v-for="(item, index) in navList" :key="index" @click="onNav(index)">{{item}}</div>
        </div>
        <div v-show="activeNav == 0" v-cloak>
            <div v-if="isblank == true && list.length > 0">
                <div class="list" :style="{background: 'url(' + bgImgy + ') no-repeat'}" v-for="(item, index) in list" :key="index">
                    <div class="money">
                        <div>￥<span>{{item.money}}</span></div>
                        <div class="full">满{{item.limit_use_money}}元可用</div>
                    </div>
                    <div class="center">
                        <div class="mark">
                            <span v-if="item.type == 1">通用券</span>
                            <span v-if="item.type == 2">专用券</span>
                        </div>
                        <div class="name">{{item.name}}</div>
                        <div class="tips">领取后{{item.limit_day}}天后失效</div>
                    </div>
                    <div class="receive" @click="onBtn(item)">立即领取</div>
                </div>
            </div>
            <div class="theblank" v-if="isblank == true && list.length <= 0">
                <TheBlank />
            </div>
        </div>
        <div v-show="activeNav == 1" v-cloak>
            <div v-if="isblank == true && lists.length > 0">
                <div class="list" :style="{backgroundImage: 'url(' + (item.status == 1 ? bgImgy : bgImgw) + ')'}" v-for="(item, index) in lists" :key="index">
                    <div class="money">
                        <div>￥<span>{{item.money}}</span></div>
                        <div class="full">满{{item.limit_use_money}}元可用</div>
                    </div>
                    <div class="center">
                        <div class="mark">
                            <span v-if="item.type == 1">通用券</span>
                            <span v-if="item.type == 2">专用券</span>
                        </div>
                        <div class="name">{{item.name}}</div>
                        <div class="tips">{{item.start_time | dasTime}}至{{item.end_time | dasTime}}</div>
                    </div>
                    <div class="receive">
                        <span v-if="item.status == 1">待使用</span>
                        <span v-if="item.status == 0 || item.status == 2">已过期</span>
                    </div>
                </div>
            </div>
            <div class="theblank" v-if="isblank == true && lists.length <= 0">
                <TheBlank />
            </div>
        </div>
        <transition name="component-fade" mode="out-in">
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
    import moment   from 'moment'
    import TheBlank from '@/components/TheBlank'
    import TheTips  from '@/components/TheTips'

    export default {
        components: {
            TheBlank,
            TheTips
        },
        data () {
            return {
                msg: null,
                navList: ['待领取', '已领取'],
                activeNav: 0,
                bgImgy: require('images/voucher.png'),
                bgImgw: require('images/voucher_no.png'),
                list: [],
                lists: [],
                accountData: {},
                h5LoginData:{},
                isblank: null
            }
        },
        filters: {
            dasTime (time) {
                return moment.unix(time).format('YYYY-MM-DD')
            }
        },
        methods: {
            onNav (index) {
                this.activeNav = index
            },
            // 领取代金券
            onBtn (item) {
                let options = {
                    appid: this.h5LoginData.appid,
                    channel: this.h5LoginData.channel,
                    uid: this.accountData.uid,
                    vid: item.id,
                    system: this.config.system,
                    // page: 1
                };
                options.sign = this.util.getSign(options, this.h5LoginData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=voucher&a=voucherGet', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.getVoucher()
                        this.msg = '领取成功'
                        setTimeout(() => {
                            this.msg = null
                        }, 1000)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                })
            },
            // 获取代金券列表
            getVoucher () {
                let options = {
                    appid: this.h5LoginData.appid,
                    channel: this.h5LoginData.channel,
                    uid: this.accountData.uid,
                    system: this.config.system,
                    // page: 1
                };
                options.sign = this.util.getSign(options, this.h5LoginData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=voucher&a=voucherList', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.list = res.data.data.uget_list ? res.data.data.uget_list : []
                        this.lists = res.data.data.get_list ? res.data.data.get_list : []
                        this.isblank = true
                        sessionStorage.setItem('setVoucher', JSON.stringify(res.data.data))
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            this.h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))
            if (sessionStorage.getItem('setVoucher')) {
                let setVoucher = JSON.parse(sessionStorage.getItem('setVoucher'))
                this.list = setVoucher.uget_list ? setVoucher.uget_list : []
                this.lists = setVoucher.get_list ? setVoucher.get_list : []
                this.isblank = true
            } else {
                this.getVoucher()
            }
        },
    }
</script>

<style lang="scss" scoped>
    [v-cloak] {
        display: none !important;
    }
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-voucher {
        margin-bottom: 60px;
        padding: 0 60px;
        overflow: hidden;
        transition: all 0.3s;
        .header {
            padding: 0 60px;
            margin: 30px 0 10px;
            display: flex;
            justify-content: space-evenly;
            .item {
                width: 210px;
                height: 90px;
                font-size: 45px;
                color: rgba(255, 255, 255, 0.5);
                border-radius: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .isitem {
                color: $color;
                border: 3px solid $color;
            }
        }
        .list {
            height: 270px;
            background-size: 100% 270px!important;
            margin-top: 30px;
            display: flex;
            .money {
                width: 270px;
                font-size: 33px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                span {
                    font-size: 60px;
                }
                .full {
                    margin-top: 30px;
                }
            }
            .center {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding-left: 45px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                .mark {
                    width: 138px;
                    height: 48px;
                    font-size: 33px;
                    border-radius: 3px;
                    background: $color;
                    margin-bottom: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .name {
                    font-size: 45px;
                    margin-bottom: 10px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .tips {
                    font-size: 36px;
                    color: rgba(255, 255, 255, 0.5);
                }
            }
            .receive {
                width: 138px;
                font-size: 39px;
                writing-mode: tb-rl;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .list:first-child {
            margin-top: 40px;
        }
        .theblank {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    // 竖屏css
    .voucher-sp {
        margin-bottom: 90px;
        padding: 0 90px;
        .header {
            padding: 0 90px;
            margin: 54px 0 18px;
            .item {
                width: 380px;
                height: 163px;
                font-size: 81px;
                border-radius: 32px;
            }
            .isitem {
                border: 5px solid $color;
            }
        }
        .list {
            height: 400px;
            background-size: 100% 400px!important;
            margin-top: 54px;
            .money {
                width: 400px;
                font-size: 50px;
                span {
                    font-size: 80px;
                }
                .full {
                    margin-top: 54px;
                }
            }
            .center {
                padding-left: 35px;
                .mark {
                    width: 250px;
                    height: 87px;
                    font-size: 55px;
                    border-radius: 5px;
                    margin-bottom: 27px;
                }
                .name {
                    font-size: 70px;
                    margin-bottom: 18px;
                }
                .tips {
                    font-size: 60px;
                }
            }
            .receive {
                width: 204px;
                font-size: 70px;
            }
        }
        .list:first-child {
            margin-top: 72px;
        }
    }
</style>